import React, { useEffect, useState } from 'react';
import { User } from '../../../../entities/User';
import { Header } from './Header';
import { Row } from 'reactstrap';
import { ScorecardBody } from './ScorecardBody';
import { InterviewQuestionsBody } from './InterviewQuestionsBody';
import { InterviewStage } from '../../../../entities/applicant_tracking/InterviewStage';
import { Application } from '../../../../entities/Application';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { SelectOption } from '../../../../components/Select';
import { JobService } from '../../../../services/applicant_tracking/JobService';
import { InterviewKitCard } from './InterviewKitCard';

interface PropTypes {
  application: Application;
  jobId: number;
  interviewStage: InterviewStage;
  user: User;
}

function convertToSelectOption(
  interviewStage: InterviewStage,
  selectedId?: number,
): SelectOption {
  return {
    value: interviewStage.id.toString(),
    label: interviewStage.name,
    selected: interviewStage.id === selectedId,
  };
}

async function loadInterviewStageOptions(
  jobId: number,
  selectedId?: number,
): Promise<SelectOption[]> {
  return (await JobService.listInterviewStages(jobId)).map(
    (interviewStage: InterviewStage) =>
      convertToSelectOption(interviewStage, selectedId),
  );
}

export default function InterviewKitPage(props: PropTypes) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [interviewStagesOptions, setInterviewStagesOptions] =
    useState<SelectOption[]>(null);

  useEffect(() => {
    (async () => {
      try {
        setInterviewStagesOptions(
          await loadInterviewStageOptions(props.jobId, props.interviewStage.id),
        );
      } catch (error: unknown) {
        setInterviewStagesOptions([]);
      }

      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Header
            application={props.application}
            interviewStagesOptions={interviewStagesOptions}
          />
          <div className='mt-4 fs-2 fw-bold'>
            {props.interviewStage.name} Kit
          </div>
          <Row className='mt-4'>
            <InterviewKitCard title='Scorecard'>
              <ScorecardBody
                user={props.user}
                scorecard={props.interviewStage.scorecard}
              />
            </InterviewKitCard>
            <InterviewKitCard title='Interview Questions'>
              <InterviewQuestionsBody
                questions={props.interviewStage.questions}
                recruiterName={props.application.job?.recruiters?.[0].name}
              />
            </InterviewKitCard>
          </Row>
        </>
      )}
    </>
  );
}
